define.alias("ember-math-helpers/helpers/exp", "media/helpers/exp");